export const weightGoalOptionsStandard = {
  loss: {
    title: 'What\'s your weekly weight loss goal?',
    selectOptions: [
      {
        optionText: 'Lose 0.5 lb',
        subtext: 'Burn an extra 250 calories daily',
        value: -0.2268
      },
      {
        optionText: 'Lose 1 lb',
        subtext: 'Burn an extra 500 calories daily',
        value: -0.4536
      },
      {
        optionText: 'Lose 1.5 lb',
        subtext: 'Burn an extra 750 calories daily',
        value: -0.6804
      },
      {
        optionText: 'Lose 2 lb',
        subtext: 'Burn an extra 1,000 calories daily',
        value: -0.9072
      }
    ]
  },
  gain: {
    title: 'What\'s your weekly weight gain goal?',
    selectOptions: [
      {
        optionText: 'Gain 0.5 lb',
        subtext: 'Intake an extra 250 calories daily',
        value: 0.2268
      },
      {
        optionText: 'Gain 1 lb',
        subtext: 'Intake an extra 500 calories daily',
        value: 0.4536
      }
    ]
  }
};

export const weightGoalOptionsMetric = {
  loss: {
    title: 'What\'s your weekly weight loss goal?',
    selectOptions: [
      {
        optionText: 'Lose 0.25 kg',
        subtext: 'Burn an extra 250 calories daily',
        value: -0.25
      },
      {
        optionText: 'Lose 0.5 kg',
        subtext: 'Burn an extra 500 calories daily',
        value: -0.5
      },
      {
        optionText: 'Lose 0.75 kg',
        subtext: 'Burn an extra 750 calories daily',
        value: -0.75
      },
      {
        optionText: 'Lose 1 kg',
        subtext: 'Burn an extra 1,000 calories daily',
        value: -1
      }
    ]
  },
  gain: {
    title: 'What\'s your weekly weight gain goal?',
    selectOptions: [
      {
        optionText: 'Gain 0.25 kg',
        subtext: 'Intake an extra 250 calories daily',
        value: 0.25
      },
      {
        optionText: 'Gain 0.5 kg',
        subtext: 'Intake an extra 500 calories daily',
        value: 0.5
      }
    ]
  }
};
